import './MapView.scss';

import React from 'react';
import {APIProvider, ColorScheme, Map} from '@vis.gl/react-google-maps';
import MapBehaviour from './MapBehaviour';
import MapItineraryPoiLayer from '../layers/MapItineraryPoiLayer';

export interface MapProps {
  googleMapsApiKey: string;
}

const MapView: React.FC<MapProps> = ({ googleMapsApiKey }) => {
  return (
      <APIProvider apiKey={googleMapsApiKey}
                   libraries={['places']}>
        <Map className={'mapview'}
             colorScheme={ColorScheme.FOLLOW_SYSTEM}
             defaultZoom={3}
             defaultCenter={{ lat: 22.54992, lng: 0 }}
             gestureHandling={'greedy'}
             disableDefaultUI={true}
             mapId={'ec48c0ed5c29b040dc38b9c6'}
        />
        <MapBehaviour/>
        <MapItineraryPoiLayer/>
      </APIProvider>
  );
};

export default MapView;
